import React from "react";
import Form from "../components/Form/Form";

const Contact = () => {
  return (
    <>
      <Form />
    </>
  );
};

export default Contact;
